import {
  Component,
  computed,
  EventEmitter,
  inject,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { MatCheckbox, MatCheckboxChange } from "@angular/material/checkbox";
import { ActivatedRoute } from "@angular/router";
import { IconComponent } from "@claas/claas-ui-components";
import { TranslatePipe } from "@ngx-translate/core";
import { ProductFamilyIconMap } from "../../../shared/models/product-family-icon-map";
import * as productFamilyIconMapJson from "../../../shared/pia-api/fam-icon-map.json";
import { DefaultProduct } from "../../../shared/pia-api/generated";
import { ProductFamilyFilterService } from "../../../shared/services/product-family-filter.service";

@Component({
  selector: "claas-product-family-filters",
  imports: [IconComponent, TranslatePipe, MatCheckbox],
  templateUrl: "./product-family-filters.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./product-family-filters.scss",
})
export class ProductFamilyFilters {
  private route = inject(ActivatedRoute);
  private productFamilyFilterService = inject(ProductFamilyFilterService);
  data = toSignal(this.route.data);
  productFamilies = computed(
    () => this.data()?.["productFamilies"] as DefaultProduct[],
  );
  productFamilyIdsExcluded = toSignal(
    this.productFamilyFilterService.excludedIds$,
  );
  productFamilyIconMap: ProductFamilyIconMap =
    productFamilyIconMapJson as ProductFamilyIconMap;

  @Output() closeFilters = new EventEmitter<void>();

  handleFilterCloseClick() {
    this.closeFilters.emit();
  }

  handleFilterCheckboxChange(evt: MatCheckboxChange, productFamilyId?: string) {
    if (productFamilyId) {
      this.productFamilyFilterService[evt.checked ? "remove" : "add"](
        productFamilyId,
      );
    }
  }
}
